export enum USER_ACCOUNT_LOADING_STATUS {
    IDLE = "idle",
    LOADING = "loading",
    READY = "ready",
}

export enum CLIENT_STATUS {
    FORM = "form",
    SUCCESS = "success",
    CODE = "code",
    ERROR = "error",
}

export enum LOGIN_ERROR {
    ClientAlreadyExists = "client_already_exists",
    ClientAlreadyAuthenticated = "client_already_authenticated",
    ClientNotFound = "client_not_found",
}

export enum CLIENT_AUTHORIZATION_PLACE {
    MAIN = "MAIN",
    MODAL = "MODAL",
}

export const DEFAULT_ERROR_MESSAGE = <>Что-то пошло не&nbsp;так, попробуйте позже.</>

export const INPUT_CLASS = "contact-request-popup__input transition-ease"
